import React from "react";
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";

const YesNoRadio = ({ label, value, onChange, disabled = false }) => (
  <FormControl component="fieldset">
    <FormLabel component="legend">{label}</FormLabel>
    <RadioGroup
      row
      value={value === true ? "yes" : value === false ? "no" : ""}
      onChange={(e) => onChange(e.target.value === "yes")}
      error={value === null || value === undefined}
    >
      <FormControlLabel
        value="yes"
        control={<Radio />}
        label="Yes"
        disabled={disabled}
      />
      <FormControlLabel
        value="no"
        control={<Radio />}
        label="No"
        disabled={disabled}
      />
    </RadioGroup>
  </FormControl>
);

export default YesNoRadio;
